// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

import { combineReducers } from 'redux';
import { ActionTypes } from 'utils/constants.jsx';

function draft(state = {}, action) {
    switch (action.type) {
        case ActionTypes.SET_PHONE_PAGE_DRAFT:
            return action.state;
        case ActionTypes.CLEAR_PHONE_PAGE_DRAFT:
            return {};
        default:
            return state;
    }
}

export default combineReducers({
    draft,
});
